import React from 'react';

export default function DefaultDeficiencies() {
  return (
    <div className="p-4 border border-gray-300 bg-white rounded-md">
      <h2 className="text-xl font-bold mb-4">Default Deficiencies</h2>

      {/* Top bar: we can mimic the bottom "Sort List Order" + version box from your screenshot */}
      <div className="flex items-center space-x-4 mb-4">
        <label className="font-semibold">
          Sort List Order:
          <select className="ml-2 border border-gray-300 rounded p-1">
            <option value="Location">Location</option>
            <option value="DeficiencyID" defaultValue>Deficiency ID</option>
            <option value="Description">Description</option>
          </select>
        </label>
        <div className="flex items-center space-x-2">
          <span>Version</span>
          <input
            type="number"
            className="w-16 border border-gray-300 rounded p-1"
            value={1}
            readOnly
          />
        </div>
        {/* Could also have a search or filter here if desired */}
      </div>

      {/* Main table */}
      <table className="w-full border-collapse text-sm">
        <thead className="bg-gray-200">
          <tr>
            <th className="border p-2">Location</th>
            <th className="border p-2">Deficiency ID</th>
            <th className="border p-2">Description</th>
            <th className="border p-2">Component</th>
            <th className="border p-2">Sub-component</th>
            <th className="border p-2">Exec Sum</th>
            <th className="border p-2">ASME Code</th>
            <th className="border p-2">ELV3 Comments</th>
            <th className="border p-2">Violating Condition</th>
            <th className="border p-2">Remedy</th>
            <th className="border p-2">C1</th>
            <th className="border p-2">C5</th>
            <th className="border p-2">MEP</th>
            <th className="border p-2">Responsibility</th>
          </tr>
        </thead>
        <tbody>
          {/* Example rows - you can replace with real data later */}
          <tr>
            <td className="border p-2">Lobby / Elevator 1</td>
            <td className="border p-2">
              <a href="#0" className="text-blue-600 underline">
                Deficiency #1
              </a>
            </td>
            <td className="border p-2">Door lock not engaging properly</td>
            <td className="border p-2">Door</td>
            <td className="border p-2">Lock Mechanism</td>
            <td className="border p-2">-</td>
            <td className="border p-2">2.14.1</td>
            <td className="border p-2">Issue with lock alignment</td>
            <td className="border p-2">Mechanical Interference</td>
            <td className="border p-2">Adjust or Replace</td>
            <td className="border p-2">X</td>
            <td className="border p-2"></td>
            <td className="border p-2">-</td>
            <td className="border p-2">Owner</td>
          </tr>
          <tr>
            <td className="border p-2">Machine Room</td>
            <td className="border p-2">
              <a href="#0" className="text-blue-600 underline">
                Deficiency #2
              </a>
            </td>
            <td className="border p-2">Oil leakage found near motor</td>
            <td className="border p-2">Motor</td>
            <td className="border p-2"></td>
            <td className="border p-2">Yes</td>
            <td className="border p-2">3.11.2</td>
            <td className="border p-2">Suspected worn seal</td>
            <td className="border p-2">Seepage</td>
            <td className="border p-2">Replace seal</td>
            <td className="border p-2"></td>
            <td className="border p-2">X</td>
            <td className="border p-2">MEP</td>
            <td className="border p-2">Maintenance Co</td>
          </tr>
          {/* Add more rows as needed */}
        </tbody>
      </table>

      {/* "OK" Button or bottom bar if desired */}
      <div className="flex justify-end mt-4">
        <button className="px-4 py-2 bg-green-600 text-white rounded hover:bg-green-700 transition">
          OK
        </button>
      </div>
    </div>
  );
}
